import React from 'react';
import moment from 'moment';

export default function ComplianceStrip({
  deviceDetails = {},
  unit = 'm³',
  onViewNoc,
  onViewCert,
  selectedMeter = '',
}) {
  const noc = deviceDetails.nocDetails || {};
  const hasNocPdf = Boolean(noc.fileName || noc.storedFileName);
  const hasNocData = Boolean(
    noc.nocNumber || noc.dailyLimit || noc.yearlyLimit || noc.startDate || noc.endDate || hasNocPdf
  );

  const cert = deviceDetails.calibrationCertificate || {};
  const hasCertPdf = Boolean(cert.fileName || cert.storedFileName);
  const hasCertData = Boolean(cert.expiryDate || cert.uploadedAt || hasCertPdf);

  return (
    <div className="compliance-strip">
      {/* 1. NOC Statutory Compliance Card */}
      <div className="compliance-card">
        <div className="comp-header">
          <div className="comp-title-group">
            <div className="comp-icon-box noc-accent">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                <path d="M9 12l2 2 4-4" />
              </svg>
            </div>
            <div style={{ minWidth: 0 }}>
              <div className="comp-label">NOC Compliance</div>
              <div className="comp-main-val" title={noc.nocNumber || ''}>
                {noc.nocNumber ? noc.nocNumber : hasNocPdf ? 'Approved Statutory NOC' : 'Not Uploaded'}
              </div>
            </div>
          </div>
          {hasNocPdf ? (
            <button
              type="button"
              className="comp-pdf-btn"
              onClick={() => onViewNoc && onViewNoc(selectedMeter, noc.fileName)}
              title={`View / Download NOC PDF (${noc.fileName || 'NOC.pdf'})`}
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
              </svg>
              <span>View PDF</span>
            </button>
          ) : (
            <span className="comp-status-badge muted">No Document</span>
          )}
        </div>

        <div className="comp-meta-grid">
          <div className="comp-meta-item">
            <span className="meta-l">Permitted Limit:</span>
            <span className="meta-v">
              {noc.dailyLimit ? `${Number(noc.dailyLimit).toLocaleString()} ${unit}/day` : '—'}
              {noc.yearlyLimit ? ` · ${Number(noc.yearlyLimit).toLocaleString()} ${unit}/yr` : ''}
            </span>
          </div>
          <div className="comp-meta-item">
            <span className="meta-l">Validity:</span>
            <span className="meta-v">
              {noc.startDate || noc.endDate ? (
                <>
                  {noc.startDate ? moment(noc.startDate).format('DD/MM/YYYY') : '-'}
                  {' to '}
                  {noc.endDate ? moment(noc.endDate).format('DD/MM/YYYY') : '-'}
                </>
              ) : (
                '—'
              )}
            </span>
          </div>
        </div>
      </div>

      {/* 2. Calibration Certificate Card */}
      <div className="compliance-card">
        <div className="comp-header">
          <div className="comp-title-group">
            <div className="comp-icon-box cert-accent">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
                <polyline points="10 9 9 9 8 9" />
              </svg>
            </div>
            <div style={{ minWidth: 0 }}>
              <div className="comp-label">Calibration Certificate</div>
              <div className="comp-main-val">
                {cert.expiryDate
                  ? `Valid to ${moment(cert.expiryDate).format('DD/MM/YYYY')}`
                  : hasCertPdf || cert.fileName
                    ? 'Certificate Uploaded'
                    : 'Not Uploaded'}
              </div>
            </div>
          </div>
          {hasCertPdf ? (
            <button
              type="button"
              className="comp-pdf-btn"
              onClick={() => onViewCert && onViewCert(selectedMeter, cert.fileName)}
              title={`View / Download Calibration Certificate (${cert.fileName || 'Certificate.pdf'})`}
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
              </svg>
              <span>View PDF</span>
            </button>
          ) : (
            <span className="comp-status-badge muted">Not Uploaded</span>
          )}
        </div>

        <div className="comp-meta-grid">
          <div className="comp-meta-item">
            <span className="meta-l">Certificate:</span>
            <span
              className="meta-v"
              style={{ maxWidth: '220px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
              title={cert.fileName || ''}
            >
              {cert.fileName || (hasCertPdf ? 'Calibration_Certificate.pdf' : '—')}
            </span>
          </div>
          {cert.uploadedAt ? (
            <div className="comp-meta-item">
              <span className="meta-l">Uploaded on:</span>
              <span className="meta-v">
                {moment(cert.uploadedAt).format('DD/MM/YYYY')}
              </span>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
